export default "__VITE_ASSET__BMR3mgGL__"